import React from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { SalahTracker } from "@/components/SalahTracker";
import { BookOpen, HeartHandshake, ChevronRight } from "lucide-react";

const TOOLS = [
  { id: "quran", icon: BookOpen, to: "/section/quran" },
  { id: "dua", icon: HeartHandshake, to: "/section/dua" },
];

export const SpiritualTools = () => {
  const { t } = useLang();
  const navigate = useNavigate();

  return (
    <section data-testid="spiritual-tools">
      <div className="mb-5 flex items-baseline justify-between">
        <h2 className="font-display text-xl font-bold tracking-tight text-[#0A192F]">{t("spiritual.title")}</h2>
        <span className="text-xs text-slate-400">{t("spiritual.subtitle")}</span>
      </div>

      <div className="mb-3.5 grid grid-cols-2 gap-3.5">
        {TOOLS.map(({ id, icon: Icon, to }) => (
          <button
            key={id}
            onClick={() => navigate(to)}
            data-testid={`spiritual-card-${id}`}
            className="group maqam-card flex flex-col items-start gap-4 p-5 text-left transition-all duration-300 ease-out hover:-translate-y-1 active:scale-[0.98]"
          >
            <div className="flex w-full items-center justify-between">
              <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[#0A192F] text-[#E9CE7D] transition-colors duration-300 group-hover:bg-[#112240]">
                <Icon size={22} strokeWidth={1.6} />
              </span>
              <ChevronRight size={16} className="text-slate-300 transition-all duration-300 group-hover:translate-x-0.5 group-hover:text-[#D4AF37]" />
            </div>
            <div className="min-w-0">
              <span className="block font-display text-[15px] font-bold leading-tight text-[#0A192F]">{t(`sec.${id}.title`)}</span>
              <span className="mt-1 block text-xs leading-snug text-slate-500">{t(`sec.${id}.desc`)}</span>
            </div>
          </button>
        ))}
      </div>

      <SalahTracker />
    </section>
  );
};
